const dev_mode= "prod";
export const baseUrl = dev_mode == "dev" ? 'dcpapi.ssasoft.com':'api.lavanderia.pk';